<template>
  <div>
    <img
      :src="handleSrc"
      alt=""
      :style="{width: this.size/2 + 'px'}"
    />
  </div>
</template>

<script>
export default {
  name: "GImg2",
  props: {
    src: {
      type: String,
      default: "",
    },
    size: {
      type: [String, Number],
      default: 60,
    }
  },
  data() {
    return {
    };
  },
  computed: {
    handleSrc() {
      let prefix = this.src.indexOf('png') !== -1 ? '' : '.png'
      return require('@/assets/images/' + this.src + prefix)
    }
  },
  components: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
</style>
